import { render, staticRenderFns } from "./ReturenDialog.vue?vue&type=template&id=12457717&scoped=true"
import script from "./ReturenDialog.vue?vue&type=script&lang=js"
export * from "./ReturenDialog.vue?vue&type=script&lang=js"
import style0 from "./ReturenDialog.vue?vue&type=style&index=0&id=12457717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12457717",
  null
  
)

export default component.exports